<template>
    <div class="flex h-screen w-screen flex-col overflow-y-hidden"
         :class="{ 'eureka-air xl:flex-row': isAirProduct, 'eureka-feature-loading': loadingFeature }">
        <template v-if="!loadingFeature">
            <NavBar v-if="isAirProduct" :headerService="headerService" />
            <PtHeader v-else class="shrink-0" :service="headerService">
                <template #logo>
                    <LogoEureka />
                </template>
                <HeaderMenu />
                <template #userPackageType>
                    <UserPackageType />
                </template>
            </PtHeader>
        </template>
        <div class="h-[calc(100vh-64px)] flex-1" :class="{ 'h-full': isAirProduct }">
            <router-view></router-view>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, onBeforeMount } from 'vue';
import { PtHeader } from 'patsnap-biz';
import { NavBar } from '@eureka/nav-bar';
import { HeaderMenu, UserPackageType } from '@eureka/header-menu-3';
import LogoEureka from '@eureka/logo-eureka';
import { controlDeferred } from '@eureka/utils/control';
import { useGlobalState } from './composables/use-global-store';
import { useHeaderService } from './composables/use-header-service';

const { headerService } = useHeaderService();

const { isAirProduct, updateIsAirProduct } = useGlobalState()
const loadingFeature = ref(false);

onBeforeMount(async() => {
    loadingFeature.value = true;
    const { is_air_product } = await controlDeferred.promise;
    updateIsAirProduct(is_air_product);
    loadingFeature.value = false;
})
</script>

<style lang="scss">
.eureka-air {

    .project-create-step,
    .project-create-chat {
        height: 100% !important;
    }

    &.eureka-feature-loading .project-create-back,
    .project-create-back {
        display: none;
    }
}
</style>
